import React, {useEffect, useState} from 'react';
import {Dispatch, bindActionCreators} from 'redux';
import {injectIntl} from 'react-intl';
import {connect} from 'react-redux';
import {RootState} from '../../reducers';
import * as actions from '../../actions/generalActions';
import * as clientActions from '../../actions/client';
import * as measuresActions from '../../actions/measures';
import './Measures.scss'
import {withRouter} from 'react-router';
import TableBbros from '../../components/Table/TableBbros';
import {ALL_MODULE_CONTENT_COLUMNS, OPTIONS} from '../../components/Table/TableConstants';
import EditIcon from '@material-ui/icons/Edit';
import {useParams} from "react-router-dom";
import {ParameterTypes} from "../../types/parameter.type";
import {setProjectName} from "../../actions/generalActions";
import DeleteIcon from "@material-ui/icons/DeleteOutline";
import DeleteModalComponent from "../../components/Modal/DeleteModal";
import ModalComponent from "../../components/Modal/ModalComponent";
import {ClientObject} from "../../types/client.type";

interface Props {
    intl: any;
    history: any;
    clientActions: any;
    measuresActions: any;
    measures: any
    actions: any;
    letter: string,
    allProjects: any,
    loading: boolean,
    client: any
}

const AllMeasures = (props: Props) => {

    const {clientId} = useParams<ParameterTypes>();
    const [moduleId, setModuleId] = useState<number>(null);
    const [isDeleteModalOpen, setDeleteModal] = useState<boolean>(false);
    useEffect(() => {
        props.actions.getModuleDataForClient('measures', clientId)
    }, [])

    useEffect(()=>{
        props.clientActions.fetchClient(clientId, 2)
    },[])

    function editMeasureData (measure) {
        localStorage.setItem('projectId', measure?.id)
        localStorage.setItem('projectName', measure?.projectName)
        props.actions.setProjectName(measure?.projectName)
        props.history.push({pathname: `/dashboard/measures/create/${measure?.id}/${clientId}`})
    }

    const fm = (id: string, defaultMessage: string) => props.intl.formatMessage({ id, defaultMessage });

    const actions = [
        {
            icon: EditIcon,
            tooltip: fm('common.action.edit', 'Edit'),
            onClick: (event: Event, rowData) => editMeasureData(rowData)
        },
        {
            icon: DeleteIcon,
            tooltip: fm('common.action.delete', 'Delete'),
            onClick: (event: Event, rowData) => deleteButtonFunction(rowData)
        }
    ]

    function deleteButtonFunction (measure) {
        setModuleId(measure?.id)
        setDeleteModal(true)
    }

    function deleteMeasure () {
        props.actions.deleteModuleData('measure', {id: moduleId})
        setDeleteModal(false)
    }

    return (
        <div className="wrapper">
            {props?.allProjects && props?.allProjects?.length !== 0 && <TableBbros
                title={props?.client?.client?.firstnameAndLastname}
                data={props?.allProjects[0]?.projects}
                columns={ALL_MODULE_CONTENT_COLUMNS}
                options={OPTIONS}
                actions={actions}
                isLoading={props.loading}
            />}
            <ModalComponent
                isModalHeader
                isOpen={isDeleteModalOpen}
                close={setDeleteModal}
            >
                <DeleteModalComponent
                    history={props.history}
                    close={() => setDeleteModal(false)}
                    deleteFunction={() => deleteMeasure()} />
            </ModalComponent>
        </div>
    )
}

function mapStateToProps(state: RootState, ownProps: any) {
    return {
        ...ownProps,
        ...state.app,
        client: state.client,
        measures: state.measures
    }
}

function mapDispatchToProps(dispatch: Dispatch<actions.ACTION>) {
    return {
        clientActions: bindActionCreators(clientActions as any, dispatch),
        measuresActions: bindActionCreators(measuresActions as any, dispatch),
        actions: bindActionCreators(actions as any, dispatch)
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(injectIntl(AllMeasures)))
